import { useController, useFormState } from "react-hook-form";
import { FormControl, FormField } from "@/components/ui/form";
import DateTimePicker from "@/components/DateTimePicker";
import { cn } from "@/lib/utils";

interface DateTimePickerFieldProps {
  name: string;
  placeholder?: string;
  className?: string;
  datePickerProps?: Record<string, unknown>;
}

export const DateTimePickerField = ({
  name,
  placeholder,
  className,
  datePickerProps,
}: DateTimePickerFieldProps) => {
  const { isSubmitting, disabled } = useFormState();
  const controller = useController({ name });
  const errorStyle = "cell-field-error";

  return (
    <FormField
      name={name}
      render={({ field }) => (
        <FormControl>
          <DateTimePicker
            {...field}
            placeholder={placeholder}
            className={cn(className, {
              [errorStyle]: controller.fieldState.error,
            })}
            datePickerProps={datePickerProps}
            disabled={isSubmitting || disabled}
          />
        </FormControl>
      )}
    />
  );
};
